(function () {
  'use strict';

  angular
    .module('wbNavigation')
    .config(config);

  function config($translateProvider) {
    $translateProvider.translations('en', {
      'navigation.learnMoreButton': 'More about our cards',
      'navigation.learnMoreButton.href': 'http://edenredkartya.hu/',
      'navigation.onlineCardManagement': 'Online Card Management',
      'navigation.newCardOrder': 'New card',
      'navigation.topUp': 'Top up card',
      'navigation.vip': 'Secure file upload',
      'navigation.previousOrders': 'Previous orders',
      'navigation.faq': 'FAQ',
      'navigation.toggle': 'Navigation',
      'navigation.languageSwitcher': 'Language switcher',
      'navigation.csnFileDownload': 'Serialnumbers by order',
      'navigation.completeCsnLists': 'Complete Serialnumber lists',
      'navigation.orderReplacementCard': 'Order replacement card',
      'navigation.multiWalletDataReconciliationList': 'Multi Wallet card data reconciliations'
    });
  }
}());
